import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit } from '@angular/core';

import { Question, UserAnswer } from './models/question.model';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from 'app/services/user.service';

declare var gtag: Function;
@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WebsiteComponent implements OnInit,AfterViewInit {
  @ViewChild('questionnaireModal', { static: true }) questionnaireModal: ModalDirective;

  isLandingPage: boolean = false;
  isChatInitialized: boolean = false;

  userAnswer: UserAnswer[] = [];
  
  questions: Question = {
    question: 'How do you manage documents and paper work in your business?',
    answers: [
      {
        answerText: 'We still use physical papers in our buisness',
        nextQuestion: {
          question: 'next Question?',
          answers: [
            {
              answerText: 'answer 1',
            },
            {
              answerText: 'answer 2',
            },

          ]
        } 
      },
      {
        answerText: 'We already use electronic documents (word, pdf ..etc)',
      },
      {
        answerText: 'Our system create highly customizable forms',
      }
    ]
  }

  constructor(
              private userService: UserService,
              private router: Router) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((route:any) => {
      let currentUrl = route.url;

      this.isLandingPage = false;

      if (currentUrl.indexOf("/landing-pages") !== -1) {
        this.isLandingPage = true;
      }
    });

    this.router.events.subscribe(event => {
      try {
        if (typeof gtag === 'function') {
          if (event instanceof NavigationEnd) {
            gtag('config', 'UA-161845474-1', 
                   {
                     'page_path': event.urlAfterRedirects
                   }
                  );
          }
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  hideModal(){
    // this.questionnaireModal.hide();
  }

}
